export const state = {
  status: [
    { tag: 'New', name: 'new' },
    { tag: 'Dispatched', name: 'dispatched' },
    { tag: 'Warehouse', name: 'warehouse' },
    { tag: 'Refunded', name: 'refunded' },
    { tag: 'Booked', name: 'booked' },
    { tag: 'Shipped', name: 'shipped' },
    { tag: 'Delivered', name: 'delivered' },
    { tag: 'Resell', name: 'resell' },
    { tag: 'Sold', name: 'sold' },
    { tag: 'Hold', name: 'hold' },
    { tag: 'Pullout', name: 'pullout' },
    { tag: 'Cancelled', name: 'cancelled' },
    { tag: 'Unloading', name: 'unloading' },
    { tag: 'Sell', name: 'sell' },
    { tag: 'Rejected', name: 'rejected' },
    { tag: 'Posted', name: 'posted' },
  ],
  deliveryTypes: [
    { tag: 'Yes', name: 'yes' },
    { tag: 'No', name: 'no' },
  ],
  consolidation: [
    { tag: 'Yes', name: 'yes' },
    { tag: 'No', name: 'no' },
  ],
  containerTypes: [
    { tag: '20', name: '20' },
    { tag: '40', name: '40' },
    { tag: '45', name: '45' },
  ],
  titleStatus: [
    { tag: 'At Auction', name: 'at_auction' },
    { tag: 'Followed Up', name: 'followed_up' },
    { tag: 'At Office', name: 'at_office' },
    { tag: 'At Warehouse', name: 'at_warehouse' },
    { tag: 'Processing At DMV', name: 'processing_at_dmv' },
    { tag: 'Picked Up', name: 'picked_up' },
    { tag: 'Mail Requested', name: 'mail_requested' },
    { tag: 'Copy Requested', name: 'copy_requested' },
    { tag: 'To Office', name: 'to_office' },
    { tag: 'To Warehouse', name: 'to_warehouse' },
  ],
  paymentFeeTypes: [{ tag: 'Payment', name: 'payment' }],
  costTypes: [
    { tag: 'Auction Cost', name: 'auction_cost' },
    { tag: 'Admin Cost', name: 'admin_cost' },
    { tag: 'Import Tax', name: 'import_tax_cost' },
    { tag: 'Interest', name: 'interest_cost' },
    { tag: 'Tittle Cost', name: 'title_cost' },
    { tag: 'License Cost', name: 'license_cost' },
    { tag: 'Order Cost', name: 'other_cost' },
    { tag: 'Shipping Cost', name: 'shipping_cost' },
    { tag: 'Towing Cost', name: 'towing_cost' },
    { tag: 'Tax', name: 'tax_cost' },
  ],
  feeTypes: [
    { tag: 'Auction Fee', name: 'auction_fee' },
    { tag: 'Admin Fee', name: 'admin_fee' },
    { tag: 'Import Tax', name: 'import_tax_fee' },
    { tag: 'Interest', name: 'interest_fee' },
    { tag: 'Tittle Fee', name: 'title_fee' },
    { tag: 'License Fee', name: 'license_fee' },
    { tag: 'Order Fee', name: 'other_fee' },
    { tag: 'Shipping Fee', name: 'shipping_fee' },
    { tag: 'Towing Fee', name: 'towing_fee' },
    { tag: 'Cutting Fee', name: 'cutting_fee' },
    { tag: 'Extra Service Fee', name: 'extra_service_fee' },
    { tag: 'Tax', name: 'tax_fee' },
    { tag: 'Fedex Fee', name: 'fedex_fee' },
  ],
  userFeeTypes: [
    { tag: 'Auction Fee', name: 'auction_fee' },
    { tag: 'Import Tax', name: 'import_tax_fee' },
    { tag: 'License Fee', name: 'license_fee' },
    { tag: 'Shipping Fee', name: 'shipping_fee' },
    { tag: 'Towing Fee', name: 'towing_fee' },
    { tag: 'Cutting Fee', name: 'cutting_fee' },
    { tag: 'Extra Service Fee', name: 'extra_service_fee' },
    { tag: 'Car Price', name: 'car_price' },
    { tag: 'Fedex Fee', name: 'fedex_fee' },
  ],
  saleDocStatus: [
    { tag: 'Yes', name: 'yes' },
    { tag: 'No', name: 'no' },
    { tag: 'Bill of Sales', name: 'bill_of_sales' },
    { tag: 'Juck Receipt', name: 'juck_receipt' },
    { tag: 'Lien Title', name: 'lien_title' },
    { tag: 'To Be Flipped', name: 'to_be_flipped' },
    { tag: 'Transfer Application', name: 'transfer_application' },
    { tag: 'Title Done', name: 'title_done' },
    { tag: 'Pay to Ship', name: 'pay_to_ship' },
    { tag: 'Title Loss', name: 'title_loss' },
  ],
}

export const getters = {
  allStatus: (state) => state.status,
  allDeliveryTypes: (state) => state.deliveryTypes,
  allConsolidations: (state) => state.consolidation,
  allTitleStatus: (state) => state.titleStatus,
  allPaymentFeeTypes: (state) => state.paymentFeeTypes,
  allFeeTypes: (state) => state.feeTypes,
  allSaleDocStatus: (state) => state.saleDocStatus,
  allCostTypes: (state) => state.costTypes,
  allUserFeeTypes: (state) => state.userFeeTypes,
  allContainerTypes: (state) => state.containerTypes,
}

export const mutations = {}

export const actions = {}
